<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center m-t-10">
        <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
          <button type="button" class="btn btn-light waves-effect" title="Actualizar" (click)="refresh()">
            <i class="fas fa-undo"></i></button>
          <div class="content__subhead__inputGrid">
            <div class="input-group" style="width: 105%;">
              <span class="input-group-prepend">
                <span class="input-group-text content__subhead__inputGrid__title">
                  <i class="far fa-calendar-alt"></i>
                </span>
              </span>
              <input type="text" id="date_range" class="form-control content__subhead__inputGrid__input">
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-6 col-12 text-right">
          <!-- <component-search (searchEvent)="search($event)"></component-search> -->
          <button type="button" class="btn btn-light btn-sm" (click)="printer()">
            <i class="fas fa-print m-r-5"></i> Imprimir
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12" id="body">
    <ng-container *ngIf="existsData">
      <div class="row">
        <!-- RECOJOS -->
        <div class="col-md-6 border-end" style="border-right: 2px solid #dee2e6;">
          <h5 class="text-center mb-3 f-s-18"><i class="fas fa-plane-arrival m-r-5 text-success"></i>
            RECOJOS (Llegadas) - <span class="m-l-5">{{totalPaxRecojos}} pax</span>
          </h5>
          <div *ngFor="let turno of ['mañana', 'tarde', 'noche']">
            <ng-container *ngIf="recojos[turno]?.length > 0">
              <h5 class="mt-3 mb-2 text-uppercase fw-semibold f-s-16" [ngClass]="{
                'text-warning': turno === 'mañana',
                'text-primary': turno === 'tarde',
                'text-secondary': turno === 'noche'
              }">
                Turno {{ turno }}
              </h5>

              <div class="card mb-2 shadow-sm border-0" *ngFor="let item of recojos[turno]">
                <div class="card-body py-2">
                  <div class="btn btn-small btn-default m-l-5 f-s-14"
                    style="padding: 3px 9px; position: absolute; right: 5px; top: 35px;" data-toggle="tooltip"
                    data-placement="right" data-original-title="Clic para copiar" (click)="copyToClipboard(item.id)">
                    <i class="far fa-copy"></i>
                  </div>
                  <h6 class="mb-1 bold">
                    <i class="fas fa-user m-r-5"></i> {{ item.booking_data.client_data.fullname }}
                    <span class="m-l-10 f-s-12">({{item.nro_pax}} pax)</span>
                  </h6>
                  <div class="text-muted small f-s-13 m-t-10 m-b-5 text-dark">
                    <i class="fas fa-phone m-r-5"></i>{{ item.booking_data.client_data.cellphone }} -
                    {{ item.booking_data.client_data.telephone }}
                  </div>
                  <div class="text-muted f-s-13 m-b-5 text-dark">
                    <i class="far fa-clock m-r-5"></i>Hora: {{ item.time_transfer }}
                  </div>
                  <div class="text-muted small f-s-13 text-dark">
                    <i class="fas fa-map-pin m-r-5"></i>{{ item.arrivalplace_data.description }} :
                    {{ item.reference_place }}
                  </div>
                </div>
                <div id="generated-data-{{item.id}}"
                  style="height: 0; margin: 0; background: transparent; z-index: 0; color: transparent;">
                  <div style="line-height: 1.2; font-size: 0;">
                    <p style="margin: 0; padding: 0;">🟢 *RECOJO CONFIRMADO* 🟢</p>
                    <div>*👤 Cliente:* {{ item.booking_data.client_data.fullname }}</div>
                    <div>*📞 Celular:* {{ item.booking_data.client_data.cellphone || '-' }} |
                      {{ item.booking_data.client_data.telephone || '-' }}
                    </div>
                    <div>*👥 Pax:* {{ item.nro_pax }}</div>
                    <div>*🕒 Hora:* {{ item.time_transfer }}</div>
                    <div>*📍 Lugar:* {{ item.arrivalplace_data.description }}</div>
                    <div>*📌 Referencia:* {{ item.reference_place }}</div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
        <!-- TRASLADOS -->
        <div class="col-md-6" style="background-color: #f7f2f2;">
          <h5 class="text-center mb-3 f-s-18"><i class="fas fa-plane-departure m-r-5 text-danger"></i> TRASLADOS
            (Salidas)
            - <span class="m-l-5">{{totalPaxTraslados}} pax</span></h5>
          <div *ngFor="let turno of ['mañana', 'tarde', 'noche']">
            <ng-container *ngIf="traslados[turno]?.length > 0">
              <h5 class="mt-3 mb-2 text-uppercase fw-semibold f-s-16" [ngClass]="{
                'text-warning': turno === 'mañana',
                'text-primary': turno === 'tarde',
                'text-secondary': turno === 'noche'
              }">
                Turno {{ turno }}
              </h5>

              <div class="card mb-2 shadow-sm border-0" *ngFor="let item of traslados[turno]">
                <div class="card-body py-2">
                  <div class="btn btn-small btn-default m-l-5 f-s-14"
                    style="padding: 3px 9px; position: absolute; right: 5px; top: 35px;" data-toggle="tooltip"
                    data-placement="right" data-original-title="Clic para copiar" (click)="copyToClipboard(item.id)">
                    <i class="far fa-copy"></i>
                  </div>
                  <h6 class="mb-1 bold">
                    <i class="fas fa-user m-r-5"></i> {{ item.booking_data.client_data.fullname }}
                    <span class="m-l-10 f-s-12">({{item.nro_pax}} pax)</span>
                  </h6>
                  <div class="text-muted small f-s-13 m-t-10 m-b-5 text-dark">
                    <i class="fas fa-phone m-r-5"></i>{{ item.booking_data.client_data.cellphone }} -
                    {{ item.booking_data.client_data.telephone }}
                  </div>
                  <div class="text-muted f-s-13 m-b-5 text-dark">
                    <i class="far fa-clock m-r-5"></i>Hora: {{ item.time_transfer }}
                  </div>
                  <div class="text-muted small f-s-13 text-dark">
                    <i class="fas fa-map-pin m-r-5"></i>{{ item.arrivalplace_data.description }} :
                    {{ item.reference_place }}
                  </div>
                </div>
                <div id="generated-data-{{item.id}}"
                  style="height: 0; margin: 0; background: transparent; z-index: 0; color: transparent;">
                  <div style="line-height: 1.2; font-size: 0;">
                    <p style="margin: 0; padding: 0;">🔴 *TRASLADO CONFIRMADO* 🔴</p>
                    <div>*👤 Cliente:* {{ item.booking_data.client_data.fullname }}</div>
                    <div>*📞 Celular:* {{ item.booking_data.client_data.cellphone || '-' }} |
                      {{ item.booking_data.client_data.telephone || '-' }}
                    </div>
                    <div>*👥 Pax:* {{ item.nro_pax }}</div>
                    <div>*🕒 Hora:* {{ item.time_transfer }}</div>
                    <div>*📍 Lugar:* {{ item.arrivalplace_data.description }}</div>
                    <div>*📌 Referencia:* {{ item.reference_place }}</div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!existsData">
      <div class="row col-lg-12">
        <p class="f-s-14">No se encontraron resultados</p>
      </div>
    </ng-container>
  </div>
</div>
